import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPastebinComponent } from './simple-icons-pastebin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPastebinComponent ],
    exports:      [ SimpleIconsPastebinComponent ],
    bootstrap:    []
})
export class SimpleIconsPastebinModule {}
